import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { pushAutoApi, type PushAutoConfig } from '@/api/push-auto.api';

export const pushAutoKeys = {
  config: ['push-auto', 'config'] as const,
  stats: ['push-auto', 'stats'] as const,
};

export function usePushAutoConfig() {
  return useQuery({
    queryKey: pushAutoKeys.config,
    queryFn: () => pushAutoApi.get(),
  });
}

export function usePushAutoStats() {
  return useQuery({
    queryKey: pushAutoKeys.stats,
    queryFn: () => pushAutoApi.stats(),
  });
}

export function useSavePushAuto() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (cfg: PushAutoConfig) => pushAutoApi.set(cfg),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['push-auto'] });
      toast.success('Push Auto guardado');
    },
    onError: () => toast.error('No se pudo guardar'),
  });
}
